import { render, staticRenderFns } from "./RhIcon.vue?vue&type=template&id=05bbba5e&"
import script from "./RhIcon.vue?vue&type=script&lang=ts&"
export * from "./RhIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports